/**
 * Column lists for reading the `predictions` table from the client.
 *
 * SECURITY: The proprietary betting-intelligence columns `pattern_references`
 * and `strategy_signals` are NOT selectable directly from the table by the
 * `anon` OR `authenticated` roles — column-level SELECT is granted only on the
 * columns below. Any `select("*")` on `predictions` will therefore fail; use
 * `PUBLIC_PREDICTION_COLUMNS` for public lists, or the `get_predictions_secure`
 * RPC (per-row redaction, honours coin unlocks) for full-row reads.
 *
 * The proprietary columns are exposed on demand only through SECURITY DEFINER
 * RPCs (`get_prediction_intelligence` for a single prediction,
 * `get_predictions_secure` for lists) which reveal them exclusively to admins
 * or to users who have spent a coin to unlock that specific prediction.
 */
export const PUBLIC_PREDICTION_COLUMNS =
  "id, match_id, market_type, predicted_outcome, confidence_score, odds, risk_level, explanation, actual_outcome, was_correct, kickoff_time, team_home, team_away, league, created_at, status, verified_at";

/**
 * The masked read path for predictions.
 *
 * `predicted_outcome` and `explanation` are no longer selectable straight off
 * the `predictions` table by `anon` / `authenticated`. This view returns them
 * only to readers entitled to the pick (match already played, admin, paid
 * reveal, free monthly reveal, or an anonymous crawler while the admin
 * indexing-access flag is ON) and NULLs them out otherwise, so the credit gate
 * is enforced by the database and not by the UI alone. It also exposes an
 * `is_revealed` boolean. Every client read of a pick must go through here.
 */
export const PREDICTIONS_READ = "predictions_public" as const;

/** Masked read path for US-sports predictions (same rules as above). */
export const US_PREDICTIONS_READ = "us_sports_predictions_public" as const;
